module.exports = __webpack_public_path__ + "static/media/ratings_white.206feade.svg";